module.exports = __webpack_public_path__ + "img/actions.63d2867c.svg";